import { render, staticRenderFns } from "./InsightCategoryEditForm.vue?vue&type=template&id=9323cba0"
import script from "./InsightCategoryEditForm.vue?vue&type=script&lang=js"
export * from "./InsightCategoryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9323cba0')) {
      api.createRecord('9323cba0', component.options)
    } else {
      api.reload('9323cba0', component.options)
    }
    module.hot.accept("./InsightCategoryEditForm.vue?vue&type=template&id=9323cba0", function () {
      api.rerender('9323cba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/InsightCategory/InsightCategoryEditForm.vue"
export default component.exports